import React from 'react';
import questionareStyle from '../../style';
import YesNo from '../YesNo';

export default function Slide1(props) {
	let style = questionareStyle();

	return (
		<div>
			<p
				style={{
					...{
						marginTop: '1rem',
					},
					...style.questionareText(),
				}}
			>
				Before we get started, I will not sugar coat anything, I will tell it like it is, and make sure you will
				get the results you deserve with the effort you put in.
			</p>
			<p
				style={{
					...{
						marginTop: '1rem',
					},
					...style.questionareText(),
				}}
			>
				Will you be able to handle this specific approach?
			</p>
			<YesNo
				nextPressed={answer => {
					props.nextPressed({
						a1: answer,
					});
				}}
			/>
		</div>
	);
}
